export type Role = 'student' | 'faculty' | 'content' | 'admin';

// Where each role lands after signing in.
export function dashboardPathForRole(role: string): string {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'faculty':
      return '/faculty';
    case 'content':
      return '/content';
    default:
      return '/dashboard';
  }
}

// Role-gated route areas, mirroring the <RequireRole> lists in App.tsx.
const ROLE_AREAS: Array<{ prefix: string; roles: Role[] }> = [
  { prefix: '/admin', roles: ['admin'] },
  { prefix: '/faculty', roles: ['faculty', 'admin'] },
  { prefix: '/content', roles: ['content', 'admin'] },
  { prefix: '/cms', roles: ['content', 'faculty', 'admin'] },
];

// Where to send someone right after they sign in. Honours the page they were
// bounced from, but never to an area their role would only get a 403 on.
export function postLoginPath(role: string, from?: string | null): string {
  const fallback = dashboardPathForRole(role);
  if (!from || !from.startsWith('/') || from.startsWith('//')) return fallback;
  if (from === '/login' || from === '/register') return fallback;

  const path = from.split(/[?#]/)[0];
  const area = ROLE_AREAS.find((a) => path === a.prefix || path.startsWith(`${a.prefix}/`));
  if (area && !area.roles.includes(role as Role)) return fallback;
  return from;
}

export const ROLE_LABEL: Record<string, string> = {
  student: 'Student',
  faculty: 'Faculty',
  content: 'Content Team',
  admin: 'Super Admin',
};
